import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FiSearch, FiTarget, FiTrendingUp, FiBarChart2, FiUsers, FiShare2, FiCamera, FiPieChart } from "react-icons/fi";
import HeroBanner from "../components/HeroBanner";
import SectionWrapper from "../components/SectionWrapper";
import marketingHero from "../assets/marketing-hero.jpg";

const seoServices = [
  { icon: FiSearch, title: "Technical SEO", desc: "Site architecture, crawlability, Core Web Vitals optimization." },
  { icon: FiTarget, title: "On-Page & Off-Page SEO", desc: "Content optimization, link building, and authority development." },
  { icon: FiTrendingUp, title: "Local SEO (UAE Focused)", desc: "Google My Business, local citations, and map pack optimization." },
  { icon: FiBarChart2, title: "Content & Keyword Strategy", desc: "Data-driven keyword research and content planning." },
];

const performanceMarketing = [
  "Google Ads & YouTube Ads",
  "Meta Ads (Facebook & Instagram)",
  "Conversion Rate Optimization",
  "Funnel & Landing Page Design",
];

const socialMedia = [
  "Content Strategy",
  "Creative Design & Reels",
  "Community Management",
  "Analytics & Reporting",
];

const DigitalMarketing = () => {
  return (
    <>
      <HeroBanner
        image={marketingHero}
        title="Digital Marketing"
        subtitle="We don't guess. We analyze, optimize, and scale your digital presence for maximum ROI."
      />

      <SectionWrapper>
        <div className="text-center mb-12">
          <h2 className="section-title mb-4">SEO <span className="text-primary">Services</span></h2>
          <p className="section-subtitle mx-auto">Comprehensive search engine optimization to boost your visibility and organic traffic.</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {seoServices.map((svc, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="card-hover flex gap-5"
            >
              <svc.icon className="w-10 h-10 text-primary flex-shrink-0" />
              <div>
                <h3 className="font-montserrat font-bold text-lg mb-2">{svc.title}</h3>
                <p className="text-muted-foreground font-roboto text-sm">{svc.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </SectionWrapper>

      <SectionWrapper className="bg-muted">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}>
            <FiTarget className="w-12 h-12 text-primary mb-4" />
            <h2 className="text-2xl md:text-3xl font-montserrat font-bold mb-6">Performance <span className="text-primary">Marketing</span></h2>
            <ul className="space-y-3">
              {performanceMarketing.map((item, i) => (
                <li key={i} className="flex items-center gap-3">
                  <FiTrendingUp className="w-5 h-5 text-primary flex-shrink-0" />
                  <span className="font-roboto text-muted-foreground">{item}</span>
                </li>
              ))}
            </ul>
          </motion.div>
          <motion.div initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}>
            <FiShare2 className="w-12 h-12 text-primary mb-4" />
            <h2 className="text-2xl md:text-3xl font-montserrat font-bold mb-6">Social Media <span className="text-primary">Marketing</span></h2>
            <ul className="space-y-3">
              {socialMedia.map((item, i) => (
                <li key={i} className="flex items-center gap-3">
                  <FiCamera className="w-5 h-5 text-primary flex-shrink-0" />
                  <span className="font-roboto text-muted-foreground">{item}</span>
                </li>
              ))}
            </ul>
          </motion.div>
        </div>
      </SectionWrapper>

      <SectionWrapper className="bg-primary text-primary-foreground text-center">
        <h2 className="text-3xl md:text-4xl font-montserrat font-bold mb-4">Ready to Grow Your Business?</h2>
        <p className="text-primary-foreground/80 font-roboto text-lg mb-8 max-w-2xl mx-auto">
          Get a free digital marketing audit and discover opportunities for growth.
        </p>
        <Link to="/contact" className="btn-hero-outline">Get Free Audit</Link>
      </SectionWrapper>
    </>
  );
};

export default DigitalMarketing;
